export function getDecodedHtml(enc) {
	if (enc) {
		if (enc.match(/&#(\d+);/g)) {
			// Pr&#233;sentation de la Soci&#233;t&#233; => 'Présentation de la Société'
			return enc.replace(/&#(\d+);/g, (_match, number) => String.fromCharCode(number));
		}
		// if there is a 25% or 1% or just the % sign by itself do not try to decode
		const leavePercentages = (enc + "").replace(/(\d+)%([,|.|\s+])|%([,|.|\s+])/, "$1%25$2");
		try {
			return decodeURIComponent((leavePercentages + "").replace(/\+/g, "%20"));
		} catch (e) {
			console.error("URI Component not decodable: " + enc);
			return enc;
		}
		//TODO: work on more robust error handling; may need to handle errors at each replace method
	}
	return "";
}
